
<div class="main-panel">
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
